import React, { useEffect } from "react";
// import { Redirect, Switch } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { getSSOTemporaryUser } from "../../GraphQL/Query/getSSOTemporaryUser";
import { Switch, useParams } from "react-router-dom";
import { handleGraphQLErrors } from "../../utils/handleGraphQLError";
import authenticateSSOTemporaryUser from "../../GraphQL/Mutation/authenticateSSOTemporaryUser";
import Cookies from "js-cookie";
import { get } from "lodash";
import { toast } from "react-toastify";
import { toastSuccessOptions } from "../../App";
import { useTranslation } from "react-i18next";
import { LoginLayout } from "../Layout/Layout";

export const ShortCode = () => {
  const { t } = useTranslation();
  /** @type {object} params */
  const params = useParams();
  const { data } = useQuery(getSSOTemporaryUser, {
    variables: {
      shortCode: params.shortCode,
    },
  });

  const [authenticate] = useMutation(authenticateSSOTemporaryUser);

  useEffect(() => {
    let timeout;

    if (
      data &&
      new Date(data?.temporaryUser?.validUntil).getTime() <=
        new Date().getTime() &&
      !data?.temporaryUser?.revoked_at
    ) {
      const redirectUrl = data.temporaryUser.link;

      timeout = setTimeout(() => {
        handleGoToApp(`${redirectUrl}`);
      }, 1500);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [data]);

  const handleGoToApp = (url) => {
    window.open(url, "_self");
  };

  async function authenticateAndRedirect(data) {
    const tempUser = data.temporaryUser;

    const authData = await authenticate({
      variables: {
        ...tempUser,
      },
    });

    const redirect = get(
      authData,
      "data.authenticateSSOTempUser.redirectLocation",
      null
    );

    Cookies.set(
      "access_level",
      get(authData, "data.authenticateSSOTempUser.SSOAccountRole", null)
    );
    Cookies.set(
      "primary_account",
      get(authData, "data.authenticateSSOTempUser.primaryAccountId", null)
    );

    return { redirect, authData };
  }

  authenticateAndRedirect(data)
    .then(({ redirect, authData }) => {
      if (redirect && authData) {
        toast(t("loginForm.redirecting"), toastSuccessOptions);
        return handleGoToApp(`${redirect}`);
      }
    })
    .catch((err) => {
      handleGraphQLErrors(err);
    });

  return (
    <div className="ShortCode">
      <LoginLayout>
        <Switch></Switch>
      </LoginLayout>
    </div>
  );
};
